import React, { useEffect } from "react";

import { Link } from "react-router-dom";
import "./index.css";
import MarketPlaceNavIcon from "../../assets/images/MarketPlaceNavIcon.png";
import MetalCloudNavIcon from "../../assets/images/MetalCloudNavIcon.png";
import ScrapRecyclingNavIcon from "../../assets/images/ScrapRecyclingNavIcon.png";
import RightHighlightedArrow from "../../assets/images/icons/rgt_arrow_vector_bl.png";

const MobileNav = ({ setModalOpen, setIsNavOpen }) => {
  // Use useEffect to disable scroll when component is mounted (open)
  useEffect(() => {
    // Disable scroll
    document.body.style.overflow = "hidden";
    // Re-enable scroll when component is unmounted (closed)
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []); // Empty dependency array to run only once when the component mounts
  return (
    <div className="mobileNavWrapper">
      <div className="navContainer">
        <div className="headerText">Solutions</div>
        <div className="navSection">
          <div className="imageContainer">
            <img src={MarketPlaceNavIcon} alt="" />
            <span className="imageText">MarketPlace</span>
          </div>
          <div className="btnSection">
            <div className="sectionText">
              <strong>One-stop</strong> Solution for Quality Procurement
            </div>
            <Link
              to="/marketplace"
              className="section-btn"
              onClick={() => setIsNavOpen(false)}
            >
              <button>Know More</button>
              <img src={RightHighlightedArrow} alt="" loading="lazy" />
            </Link>
          </div>
        </div>
        <div className="navSection">
          <div className="imageContainer">
            <img src={MetalCloudNavIcon} alt="" />
            <span className="imageText">MetalCloud</span>
          </div>
          <div className="btnSection">
            <div className="sectionText">
              Your Entire Shop Floor on{" "}
              <strong>One AI Execution System</strong>
            </div>
            <Link
              to="/metalcloud"
              className="section-btn"
              onClick={() => setIsNavOpen(false)}
            >
              <button>Know More</button>
              <img src={RightHighlightedArrow} alt="" loading="lazy" />
            </Link>
          </div>
        </div>
        <div className="navSection">
          <div className="imageContainer">
            <img src={ScrapRecyclingNavIcon} alt="" />
            <span className="imageText" style={{ top: "30%" }}>
              Scrap Recycling
            </span>
          </div>
          <div className="btnSection">
            <div className="sectionText">
              <strong>Rethinking</strong> Resources, <strong>Reshaping</strong>{" "}
              Sustainability
            </div>
            <Link
              to="/scrap-recycling"
              className="section-btn"
              onClick={() => setIsNavOpen(false)}
            >
              <button>Know More</button>
              <img src={RightHighlightedArrow} alt="" loading="lazy" />
            </Link>
          </div>
        </div>
        {/* <div className="navSection">
          <div
            className="btnSection"
            style={{ width: "100%", padding: "0 15px" }}
          >
            <div className="sectionText">
              <strong>Finance Webinar:</strong> How Foundries Are Growing Faster
            </div>
            <a href="/finance-webinar" className="section-btn">
              <button>Register Now</button>
              <img src={RightHighlightedArrow} alt="" loading="lazy" />
            </a>
          </div>
        </div> */}
      </div>
      <div className="navContainer">
        <Link
          to="/culture"
          className="headerText"
          onClick={() => setIsNavOpen(false)}
        >
          <span>Culture</span>
          <img className="grayArrow" src={RightHighlightedArrow} alt="" />
        </Link>
      </div>
      <div className="navContainer">
        <Link
          to="/careers"
          className="headerText"
          onClick={() => setIsNavOpen(false)}
        >
          <span>Careers</span>
          <img className="grayArrow" src={RightHighlightedArrow} alt="" />
        </Link>
      </div>
      <button
        onClick={() => setModalOpen(true)}
        className="getInTouchBtn"
      >
        Get In Touch
      </button>
    </div>
  );
};

export default MobileNav;
